// extracted by mini-css-extract-plugin
export var text = "border-module--text--yNYGU";
export var fadein = "border-module--fadein--Fm3oC";